import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import { UserCheck, Users, ShieldAlert, TrendingUp } from "lucide-react";

const UserAnalytics = () => {
  const { data: profiles } = useQuery({
    queryKey: ['user-analytics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*');
      if (error) throw error;
      return data;
    }
  });

  const metrics = [
    {
      title: "Total Users",
      value: profiles?.length || 0,
      icon: Users,
      color: "blue"
    },
    {
      title: "Verified Users",
      value: profiles?.filter(p => p.role)?.length || 0,
      icon: UserCheck,
      color: "green"
    },
    {
      title: "Risk Alerts",
      value: "Low",
      icon: ShieldAlert,
      color: "yellow"
    },
    {
      title: "Growth Rate",
      value: "+12%",
      icon: TrendingUp,
      color: "purple"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics.map((metric, index) => (
          <Card key={index} className="p-6 hover:shadow-lg transition-all duration-200">
            <div className="flex items-center gap-4">
              <div className={`p-3 bg-${metric.color}-100 rounded-full`}>
                <metric.icon className={`h-6 w-6 text-${metric.color}-600`} />
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">{metric.title}</p>
                <h3 className="text-2xl font-bold">{metric.value}</h3>
              </div>
            </div>
          </Card>
        ))}
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">User Growth Trend</h3>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={[
              { month: 'Jan', users: 100 },
              { month: 'Feb', users: 120 },
              { month: 'Mar', users: 150 },
              { month: 'Apr', users: 180 },
            ]}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="users" stroke="#8884d8" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

export default UserAnalytics;